// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  DOWNLOAD_HOME_DATA,
  SUCCESS_DOWNLOAD_HOME_DATA,
  ERROR_DOWNLOAD_HOME_DATA
} from '../types/index'



// State Reducer
const initialState = {
  error: false,
  isLoad: false,
  title: '',
  subtitle: '',
  video: ''
  // title: 'DEDICA UN chempasúchil <span class="flowers"> a tu ser amado </span>',
}



// Reducer
export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case DOWNLOAD_HOME_DATA:
      return {
        ...state,
        error: false,
        isLoad: true
      }
    case SUCCESS_DOWNLOAD_HOME_DATA:
      const homePayload = action.payload.home
      return {
        ...state,
        title: homePayload.title,
        subtitle: homePayload.text,
        video: homePayload.video,
        error: false,
        isLoad: false
      }
    case ERROR_DOWNLOAD_HOME_DATA:
      return {
        ...state,
        error: true,
        isLoad: false
      }
    default:
      return {
        ...state
      }
  }
}
